import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Actions, Input, MonthActions } from "@website/ui/datepicker/components";
import styles from "@website/ui/datepicker/components/header/header.module.scss";
import { HeaderPropertiesType } from "@website/ui/datepicker/components/header/header.types";
import { WEEK_ABBR } from "@website/ui/datepicker/constanst";
import { TopAppBar } from "@website/ui/top-app-bar";
import { FC } from "react";
export const Header: FC<HeaderPropertiesType> = properties => {
  const $ = _c(33);
  const {
    calendarLocale: t0,
    showDates,
    inputProperties,
    scrolled,
    onClose,
    showToday,
    changeCalendarLocale,
    showPreviousMonth,
    showNextMonth,
    nextMonthDisabled,
    previousMonthDisabled,
    type,
    view,
    backButton
  } = properties;
  const calendarLocale = t0 === undefined ? "gregorian" : t0;
  const t1 = `${styles.header} ${styles["rtl" || "ltr"]} ${scrolled ? styles.scrolled : ""}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MaterialIcon name="arrow_forward" variant="outlined" />;
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== backButton || $[2] !== onClose) {
    t3 = <div className={styles["top-app-bar"]}><TopAppBar StartAction={<Button EndIcon={t2} color="neutral" equalDimension={true} onClick={() => {
        onClose();
        if (backButton) {
          setTimeout(backButton, 100);
        }
      }} variant="text" />} title={"\u0627\u0646\u062A\u062E\u0627\u0628 \u062A\u0627\u0631\u06CC\u062E"} /></div>;
    $[1] = backButton;
    $[2] = onClose;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== calendarLocale || $[5] !== changeCalendarLocale || $[6] !== showToday) {
    t4 = <Actions calendarLocale={calendarLocale} changeCalendarLocale={changeCalendarLocale} showToday={showToday} />;
    $[4] = calendarLocale;
    $[5] = changeCalendarLocale;
    $[6] = showToday;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== inputProperties) {
    t5 = <div className={styles["input-container"]}><Input {...inputProperties} disabled={true} fullWidth={true} isCalendarHeader={true} /></div>;
    $[8] = inputProperties;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className={styles["part-one"]}>{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== calendarLocale || $[14] !== nextMonthDisabled || $[15] !== previousMonthDisabled || $[16] !== showDates || $[17] !== showNextMonth || $[18] !== showPreviousMonth || $[19] !== type) {
    t7 = <MonthActions calendarLocale={calendarLocale} nextMonthDisabled={nextMonthDisabled} previousMonthDisabled={previousMonthDisabled} showDates={showDates} showNextMonth={showNextMonth} showPreviousMonth={showPreviousMonth} type={type} />;
    $[13] = calendarLocale;
    $[14] = nextMonthDisabled;
    $[15] = previousMonthDisabled;
    $[16] = showDates;
    $[17] = showNextMonth;
    $[18] = showPreviousMonth;
    $[19] = type;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  const t8 = `${styles["week-names-container-mobile"]} ${view === "mobile" ? "" : styles["week-names-container-mobile__default"]}`;
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [1, 2, 3, 4, 5, 6, 7];
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== calendarLocale) {
    t10 = t9.map(item => <div className={styles["week-name"]} key={item}>{WEEK_ABBR[calendarLocale]?.[item - 1] || WEEK_ABBR.gregorian[item - 1]}</div>);
    $[22] = calendarLocale;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t8) {
    t11 = <div className={t8}>{t10}</div>;
    $[24] = t10;
    $[25] = t8;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t1 || $[28] !== t11 || $[29] !== t3 || $[30] !== t6 || $[31] !== t7) {
    t12 = <div className={t1}>{t3}{t6}{t7}{t11}</div>;
    $[27] = t1;
    $[28] = t11;
    $[29] = t3;
    $[30] = t6;
    $[31] = t7;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  return t12;
};